import { initializeApp } from 'firebase/app'
import { GoogleAuthProvider, getAuth, signInWithEmailAndPassword, signInWithPopup, signOut } from 'firebase/auth'
import { env } from './env'

// The panel signs in against the same Firebase project as the customer app for
// now; a separate one will replace it, and this file is the only place to change.
const app = initializeApp(env.firebase)
export const auth = getAuth(app)

export const signInWithGoogle = () => signInWithPopup(auth, new GoogleAuthProvider())
export const signInWithEmail = (email: string, password: string) => signInWithEmailAndPassword(auth, email, password)
export const logout = () => signOut(auth)
